const icons = {
	email: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 6 10-6"/>',
	phone: '<path d="M22 16.9v3a2 2 0 0 1-2.2 2A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7l.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4l2.8.7a2 2 0 0 1 1.7 2z"/>',
	name: '<path d="M20 21v-2a6 6 0 0 0-6-6h-4a6 6 0 0 0-6 6v2"/><circle cx="12" cy="6" r="4"/>',
	message: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
	password: '<rect x="4" y="10" width="16" height="12" rx="2"/><path d="M8 10V6a4 4 0 0 1 8 0v4"/>',
	url: '<path d="m10 13 4-4m-6 7-2 2a4 4 0 0 1-6-6l5-5a4 4 0 0 1 6 0m2 1 2-2a4 4 0 0 1 6 6l-5 5a4 4 0 0 1-6 0"/>',
	default: '<rect x="3" y="7" width="18" height="14" rx="2"/><path d="M8 7V3h8v4M3 12h18"/>',
};

export function mountFormDesign(root = document) {
	root.querySelectorAll('.solufy-site form, .cc-root form').forEach((form, formIndex) => {
		if (form.dataset.formDesignMounted) return;
		form.dataset.formDesignMounted = 'true';
		if (!form.id) form.id = `solufy-website-form-${formIndex}`;
		form.classList.add('solufy-form-ui');
		if (form.matches('[role="search"]')) {
			form.classList.add('solufy-form-ui--search');
			return;
		}
		form.querySelectorAll('input, textarea, select').forEach((input, index) => {
			if (input.matches('[type="hidden"], [type="file"], [type="checkbox"], [type="radio"], [type="submit"], [tabindex="-1"], [aria-hidden="true"], .career-honeypot, .solufy-honeypot')) return;
			if (input.closest('.solufy-field-box')) return;
			styleField(form, input, index);
		});
	});
}

function styleField(form, input, index) {
	if (!input.id) input.id = `${form.id || 'website-form'}-field-${index}`;
	let field = input.closest('.form-field, .form-group, .solufy-form-group, .lead-chat-country');
	let label = field?.querySelector('label, :scope > span');
	if (!field) {
		label = [...form.querySelectorAll('label')].find(item => item.htmlFor === input.id);
		if (!label) return;
		field = document.createElement('div');
		input.before(field);
		field.append(label, input);
	}
	if (!label || field.classList.contains('solufy-field-box')) return;
	const help = field.querySelector(':scope > p:has(a[href="#forgot"])');
	if (help) field.after(help);
	field.classList.add('solufy-field-box');
	if (input.matches('textarea')) field.classList.add('solufy-field-box--textarea');
	label.classList.add('solufy-field-box__label');
	if (label.tagName === 'LABEL') label.htmlFor = input.id;
	const inner = document.createElement('div');
	inner.className = 'solufy-field-box__inner';
	inner.append(...field.childNodes);
	const icon = document.createElement('span');
	icon.className = 'solufy-field-box__icon';
	icon.setAttribute('aria-hidden', 'true');
	const kind = input.type === 'password' ? 'password'
		: /email|usr/.test(input.name + input.id) ? 'email'
			: /phone|tel/.test(input.name + input.type) ? 'phone'
				: /name/.test(input.name) ? 'name'
					: input.matches('textarea') ? 'message' : input.type === 'url' ? 'url' : 'default';
	icon.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${icons[kind]}</svg>`;
	field.append(icon, inner);
}
